<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top rounded-bottom shadow">
      <div class="container-fluid">
        <router-link class="navbar-brand" to="/">
          <i class="fas fa-user-circle me-2"></i>
          Panel Asdecode
        </router-link>
        
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarClient">
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <div class="collapse navbar-collapse" id="navbarClient">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/" exact-active-class="active">
                <i class="fas fa-home me-1"></i> Accueil
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/profil" active-class="active">
                <i class="fas fa-user me-1"></i> Profil
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/realisations" active-class="active">
                <i class="fas fa-trophy me-1"></i> Réalisations
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/missions" active-class="active">
                <i class="fa-regular fa-folder-open me-1"></i> Missions
              </router-link>
            </li> -->
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/factures" active-class="active">
                <i class="fas fa-layer-group me-1"></i> Facturation
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/messages" active-class="active">
                <i class="fa-solid fa-envelope me-1"></i> Messages
              </router-link>
            </li> -->
          </ul>
          
          <div class="d-flex">
            <button class="btn btn-outline-danger text-white rounded-pill" @click.prevent="logout">
              <i class="fas fa-sign-out-alt me-1"></i> Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'ClientNavbar',
    methods: {
      logout() {
        if(!confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
          return;
        }
        if (this.$router.push({ name: 'login' })) {
          this.$store.commit('clearUserData');
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .navbar {
    padding: 0.5rem 1rem;
  }
  
  .nav-link {
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    margin: 0 0.2rem;
    transition: all 0.3s;
  }
  
  .nav-link:hover, .nav-link.active {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .dropdown-menu {
    border: none;
  }
  </style>